// extracted by mini-css-extract-plugin
export default {"container":"xN-z","topReviewHeading":"yN-z","criticalReview":"zN-z","favorableReview":"AN-z","vsSeparator":"BN-z"};